module.exports = __webpack_public_path__ + "static/media/nike-oranje-fatalis-1.c7f5085d.jpg";